<template>
	<div>
		<div class="columns">
			<div class="column is-6">
				<figure class="image image-contain-height height-330 radius-lg-img">
					<lazy-load v-if="renderComponent"
					src="/front/img/spinner.svg"
					:lazy-src="activeImage ? activeImage : '/front/img/about-img.png'"
					:lazy-srcset="activeImage ? activeImage : '/front/img/about-img.png'"
					background-color="transparent"
					alt="slider"
					class="mr-auto delay-4 mt0"
					/>
				</figure>
			</div>
			<div class="column is-6">
				<carousel-3d id="about-slider" @after-slide-change="onAfterSlideChange" :clickable="true" :controls-prev-html="`<i class='fas fa-caret-left has-text-primary'></i>`" :controls-next-html="`<i class='fas fa-caret-right has-text-primary'></i>`"  :autoplay='false' :display="2" :dir="sitelocale == 'ar' ? 'rtl' : 'ltr' " :space="370" :height="275" :width="410" :controlsVisible="true" class="about-carousel">
					<slide  v-for="(card, index) in aboutInfo" v-bind:key="index" :index="index" class="p30">
						<div>
							<a rel="noreferrer" href="#">
								<span class="has-text-white is-size-4 has-text-weight-bold">{{card.title}}</span>
							</a>
							<div class="height-175 overflow-y has-text-white text-scroll pl10 has-text-weight-bold mt10">
								<span class="is-size-3 ml10"><i class="icon_right_quotes"></i></span>
								<span class="has-text-white" v-html="card.content"></span>
								<span class="is-size-3 has-text-left mr10"><i class="icon_left_quotes"></i></span>
							</div>
						</div>
					</slide>
				</carousel-3d>
			</div>
		</div>
	</div>
</template>

<script>
	import LazyLoad from '../GeneralComponents/LazyLoad';
	export default {
		name: "about",
		props: {
			sitelocale:{
				type: String,
				required: true
			},
			InfoInput:{
				required: true
			}

		},
		components: {
			LazyLoad ,
		},
		data(){
			return{
				aboutInfo:[],
				activeImage: null,
				renderComponent: true,
			}

		},
		created(){
			this.aboutInfo = this.InfoInput;
			this.activeImage = this.aboutInfo[0].image;
		},
		methods:{
			forceRerender() {
				this.renderComponent = false;
				this.$nextTick(() => {
					this.renderComponent = true;
				});
			},
			onAfterSlideChange(index) {
				this.forceRerender();
				this.activeImage = this.aboutInfo[index].image;
			},
		}
	}
</script>
<style>

</style>
